import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Instagram, MessageCircle, Music, Twitter } from "lucide-react";

export default function GiveawayFooter() {
  const navLinks = [
    { label: "הרשמה", href: "/SignIn" },
  ];

  const socialLinks = [
    { icon: Linkedin, href: "https://www.linkedin.com/company/mom3ntum-io/" },
    { icon: Instagram, href: "https://www.instagram.com/mom3ntum.fans" },
    { icon: MessageCircle, href: "https://discord.gg/mom3ntum" },
    { icon: Music, href: "https://t.me/mom3ntum" },
    { icon: Twitter, href: "https://x.com/mom3ntum_io" },
  ];

  return (
    <footer dir="rtl" style={{ background: "#1B1B1B", borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: "40px", paddingBottom: "40px" }}>
      <div className="max-w-6xl mx-auto px-4">
        {/* Top navigation links — centered */}
        <div className="flex flex-wrap justify-center gap-11 mb-10">
          {navLinks.map(({ label, href }) => (
            <Link key={label} to={href} className="text-sm font-medium transition-opacity hover:opacity-75" style={{ color: "#C4C4C4", fontFamily: "'IBM Plex Sans Hebrew', sans-serif" }}>
              {label}
            </Link>
          ))}
        </div>

        {/* Middle section — stacked on mobile, side-by-side on desktop */}
        <div className="flex flex-col items-center gap-8 md:flex-row md:items-start md:justify-between mb-10">
          {/* Logo + Partner */}
          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 text-center sm:text-right">
            {/* Logo + tagline */}
            <div className="flex flex-col items-center sm:items-end gap-3">
              <img
                src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/69b41710d6b60acb7a810a52/28c9e5e33_4001c01a136bfa7e8fad11199ee4302cb6172305.png"
                alt="Mom3ntum"
                className="h-6 object-contain max-w-[200px]"
              />
              <p className="text-sm leading-snug" style={{ color: "#C4C4C4", fontFamily: "'Heebo', sans-serif", maxWidth: "286px" }}>
                כרטיסים לאירועי הענק במחיר עלות. ללא ספסרות.
              </p>
            </div>

            {/* Partner section */}
            <div className="flex flex-col items-center sm:items-end gap-3">
              <p className="text-sm" style={{ color: "#C4C4C4", fontFamily: "'Heebo', sans-serif" }}>בשיתוף</p>
              <img
                src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/69b41710d6b60acb7a810a52/74fce56ce_.png"
                alt="קשרי תעופה"
                className="h-5 object-contain max-w-[150px]"
                style={{ opacity: 0.55 }}
              />
            </div>
          </div>

          {/* Social icons */}
          <div className="flex gap-5 flex-shrink-0">
            {socialLinks.map(({ icon: Icon, href }) => (
              <a key={href} href={href} target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-60">
                <Icon className="w-6 h-6" style={{ color: "#858585" }} />
              </a>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", margin: "24px 0" }} />

        {/* Copyright */}
        <div className="text-center">
          <p className="text-sm" style={{ color: "#C4C4C4", fontFamily: "'IBM Plex Sans Hebrew', sans-serif", fontWeight: 400 }}>
            © 2026 Mom3ntum · כל הזכויות שמורות · בחירת הזוכים במבצע בשיקול דעת בלעדי של Mom3ntum
          </p>
        </div>
      </div>
    </footer>
  );
}
